import React, { useContext } from "react";
import "./CampainsCard.css";
import { Context } from "../../context/Context";
import { useAccess } from "../../access/hooks/useAccess";
import { translations } from "../../utils/lang";
import { Button, Card, Tags } from "../ui";

export const CampainsCard = ({
  app,
  type,
  field,
  value,
  onUpdate,
  isDash = false,
  // Optional extra content below the text (the Campaigns page puts the
  // Operations actions and request statuses here).
  extra = null,
}) => {
  const { lang } = useContext(Context);
  const { can } = useAccess();

  const typeVariant = {
    deliveryCamp: "success",
    paidCamp: "danger",
  };

  return (
    <Card
      className="campain-card"
      title={translations[lang].appsNames[app] || translations[lang].notApp}
      actions={
        <Tags
          variant={typeVariant[field] || "neutral"}
          appearance="soft"
          size="sm"
        >
          {type}
        </Tags>
      }
    >
      <div className="campain-card-body">
        <p>{value?.[lang]}</p>
      </div>

      <div className="campain-card-actions">
        {extra}

        {can("campaign.manage") && !isDash && (
          <Button
            variant="primary"
            appearance="soft"
            size="sm"
            onClick={onUpdate}
          >
            {translations[lang].financial.update}
          </Button>
        )}
      </div>
    </Card>
  );
};
